<template>
  <v-dialog v-model="dialog" max-width="1700px">
    <template v-slot:activator="{ on, attrs }" v-if="externalAccess == false">
      <v-btn text medium icon v-bind="attrs" v-on="on">
        <v-icon medium color="red lighten-1"> mdi-magnify </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-app-bar dark dense color="red lighten-1" elevation="0">
        <v-col class="d-flex justify-start">
          <v-toolbar-title>Detalhes da Nota Fiscal</v-toolbar-title>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn text medium icon @click="closeModal()">
            <v-icon medium color="white lighten-1" class="mdi-rotate-45"> mdi-plus-circle </v-icon>
          </v-btn>
        </v-col>
      </v-app-bar>
      <v-container>
        <v-row>
          <v-col cols="6" class="pl-5">
            <v-row>
              <v-col
                cols="12"
                style="
                  max-height: 70vh;
                  border-left-style: solid;
                  border-color: #707070;
                  padding: 0px;
                "
              >
                <div
                  style="height: 8%; background-image: linear-gradient(to right, #707070, #484848)"
                  class="d-flex justify-end align-center"
                >
                  <v-btn text medium icon class="mr-2" @click="printInvoice()">
                    <v-icon medium color="white lighten-1"> mdi-cloud-download </v-icon>
                  </v-btn>
                </div>
                <div
                  style="
                    height: 90%;
                    overflow-y: auto !important;
                    -webkit-overflow-scrolling: touch;
                    -moz-overflow-scrolling: touch '; -ms-overflow-scrolling: touch';
                    overflow-scrolling: touch;
                  "
                >
                  <div
                    v-if="loadedRatio > 0 && loadedRatio < 1"
                    style="background-color: red; color: white; text-align: center"
                    :style="{ width: loadedRatio * 100 + '%' }"
                  >
                    {{ Math.floor(loadedRatio * 100) }}%
                  </div>
                  <pdf
                    v-for="i in numPages"
                    @progress="loadedRatio = $event"
                    :key="i"
                    :src="src"
                    :page="i"
                    ref="pdf"
                  ></pdf>
                </div>
                <div
                  style="height: 2%; background-image: linear-gradient(to right, #707070, #484848)"
                ></div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row class="ml-2 mt-3">
              <v-col cols="4">
                <b>Numero NF: </b> <br />
                {{ specified_invoice.nf_number }}
              </v-col>
              <v-col cols="4">
                <b>Data da Compra: </b><br />
                {{ specified_invoice.acquisition_date }}
              </v-col>
              <v-col cols="4">
                <b>Fonte da Aquisição: </b><br />
                {{ specified_invoice.acquisition_source }}
              </v-col>
              <v-col cols="4">
                <b>Tipo da Aquisição: </b><br />
                {{ specified_invoice.acquisition_type }}
              </v-col>
              <v-col cols="8">
                <b>Fornecedor: </b><br />
                {{ specified_invoice.provider }}
              </v-col>
            </v-row>
            <v-card>
              <v-app-bar dark dense color="red lighten-1" elevation="0">
                <v-col class="d-flex justify-start">
                  <v-toolbar-title>Lista de Itens Presentes na Nota Fiscal</v-toolbar-title>
                </v-col>
                <v-col class="d-flex justify-end">
                  <NewInvoiceItemForm :invoiceId="invoiceId" />
                </v-col>
              </v-app-bar>
              <v-data-table :headers="headers" :items="filtered_invoice_items" :items-per-page="4">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-row>
                    <v-col class="d-flex justify-end">
                      <InvoiceItemDetailing :itemId="item.id" />
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td>
                      <b>Total:</b>
                    </td>
                    <td colspan="3">
                      <v-col class="d-flex justify-end">
                        <b>R$ {{ total_price }} </b>
                      </v-col>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import pdf from 'vue-pdf'
import * as api from '@/http'
import NewInvoiceItemForm from '@/views/invoice/components/NewInvoiceItemForm'
import InvoiceItemDetailing from '@/views/invoice/components/InvoiceItemDetailing'

export default {
  name: 'InvoiceDetailing',
  src: '',
  components: { pdf, NewInvoiceItemForm, InvoiceItemDetailing },
  props: { invoiceId: Number, externalAccess: Boolean },
  data: () => ({
    dialog: false,
    filtered_invoice_items: [],
    total_price: 0,
    specified_invoice: {},
    loadedRatio: 0,
    page: 1,
    numPages: undefined,
    headers: [
      {
        text: 'Qtd. Adiquirida',
        align: 'start',
        value: 'amount',
      },
      { text: 'Qtd. Tombada', value: 'number_of_registered' },
      { text: 'Item', value: 'description' },
      { text: 'Preço Unit.', value: 'unit_price' },
      { text: '', value: 'actions', sortable: false },
    ],
  }),
  created() {
    if (!!this.externalAccess) {
      this.dialog = true
    }

    this.specified_invoice = this.GET_specifiedInvoice(this.invoiceId)

    this.src = this.downloadInvoice(this.specified_invoice.id).then((response) => {
      this.src = pdf.createLoadingTask(response)

      this.src.promise.then((pdf) => {
        this.numPages = pdf.numPages
      })
    })

    this.filtered_invoice_items = [
      ...this.invoice_items.filter((filtered) => {
        return filtered.invoice_id == this.invoiceId
      }),
    ]

    this.filtered_invoice_items.forEach((item) => {
      // item.unit_price = 'R$ ' + item.unit_price
      // let price = item.unit_price.split(' ')
      let price = item.unit_price * item.amount
      this.total_price = this.total_price + price
    })
    this.total_price = this.total_price.toFixed(2)
  },
  computed: {
    ...mapGetters('acquisitions', ['GET_specifiedInvoice']),
    ...mapState('acquisitions', ['invoice_items']),
  },
  watch: {
    invoice_items: function () {
      this.total_price = 0
      this.filtered_invoice_items = [
        ...this.invoice_items.filter((filtered) => {
          return filtered.invoice_id == this.invoiceId
        }),
      ]

      this.filtered_invoice_items.forEach((item) => {
        // item.unit_price = 'R$ ' + item.unit_price
        // let price = item.unit_price.split(' ')
        let price = item.unit_price * item.amount
        this.total_price = this.total_price + price
      })
    },
    total_price: function () {
      this.total_price = parseFloat(this.total_price).toFixed(2)
    },
  },
  methods: {
    ...mapActions('acquisitions', ['ActionClearNewInvoice']),

    closeModal() {
      this.ActionClearNewInvoice()
      this.dialog = false
    },

    printInvoice() {
      let url = this.downloadInvoice(this.specified_invoice.id).then((response) => {
        window.open(response)
      })
    },

    async downloadInvoice(id) {
      const name = 'teste'
      const request = await api.http.post(
        `dash/acquisitions/invoice/${id}`,
        { id },
        {
          responseType: 'arraybuffer',
        }
      )

      var out = new Blob([request.data], { type: 'application/pdf' })
      var _global =
        typeof window === 'object' && window.window === window
          ? window
          : typeof self === 'object' && self.self === self
          ? self
          : typeof global === 'object' && global.global === global
          ? global
          : this

      var force = out.type === 'application/octet-stream'
      var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari
      var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent)
      var isMacOSWebView =
        /Macintosh/.test(navigator.userAgent) &&
        /AppleWebKit/.test(navigator.userAgent) &&
        !/Safari/.test(navigator.userAgent)

      if (
        (isChromeIOS || (force && isSafari) || isMacOSWebView) &&
        typeof FileReader !== 'undefined'
      ) {
        // Safari doesn't allow downloading of blob URLs
        var reader = new FileReader()
        return reader.readAsDataURL(out)
      } else {
        var URL = _global.URL || _global.webkitURL
        var url = URL.createObjectURL(out)
        setTimeout(function () {
          URL.revokeObjectURL(url)
        }, 2000)
      }

      return url
    },
  },
}
</script>